import React from "react";

interface HamburgerProps {
  onClick?: React.MouseEventHandler<SVGSVGElement>;
  style?: React.CSSProperties;
  className?: string;
}

const Hamburger = ({ onClick, style, className }: HamburgerProps): JSX.Element => {
  return (
    <svg
      width="22"
      height="13"
      viewBox="0 0 22 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      className={className}
      onClick={onClick}
    >
      <path d="M1.66602 0.583984C1.2518 0.583984 0.916016 0.919771 0.916016 1.33398C0.916016 1.7482 1.2518 2.08398 1.66602 2.08398V0.583984ZM20.3327 2.08398C20.7469 2.08398 21.0827 1.7482 21.0827 1.33398C21.0827 0.919771 20.7469 0.583984 20.3327 0.583984V2.08398ZM1.66602 5.91732C1.2518 5.91732 0.916016 6.2531 0.916016 6.66732C0.916016 7.08153 1.2518 7.41732 1.66602 7.41732V5.91732ZM17.666 7.41732C18.0802 7.41732 18.416 7.08153 18.416 6.66732C18.416 6.2531 18.0802 5.91732 17.666 5.91732V7.41732ZM1.66602 11.2507C1.2518 11.2507 0.916016 11.5864 0.916016 12.0007C0.916016 12.4149 1.2518 12.7507 1.66602 12.7507V11.2507ZM10.9993 12.7507C11.4136 12.7507 11.7493 12.4149 11.7493 12.0007C11.7493 11.5864 11.4136 11.2507 10.9993 11.2507V12.7507ZM1.66602 2.08398H20.3327V0.583984H1.66602V2.08398ZM1.66602 7.41732H17.666V5.91732H1.66602V7.41732ZM1.66602 12.7507H10.9993V11.2507H1.66602V12.7507Z" fill="#999B9F"/>
    </svg>
  );
};

export default Hamburger;